import RadioButtonQuest from "../../../../UI/RadioButtonQuest";

const EverIncreCredLimit = ({
  setEverIncreased,
  onSelectAnswer,
  backClick,
  clsName,
  removeFromPending,
}) => {
  const optionHandle = async (e) => {
    // GtmDataLayer({
    //     question: "limit increase",
    // });

    if (e.target.value === "247") {
      setEverIncreased("247");
      onSelectAnswer(e);
    } else if (e.target.value === "248") {
      setEverIncreased("248");
      onSelectAnswer(e);
      removeFromPending("bankActedIrresponsibly");
      removeFromPending("highestCreditLimit");
    }
  };
  return (
    <div className={`qsSlider slidea5 ${clsName}`}>
      <h2 className="qs-title slide-up-now">
        {" "}
        Was your overdraft credit limit ever increased?
      </h2>
      <ul className="btn-option optinal-items  two-options  slide-up-now">
        <li>
          <div className=" option_but ">
            <RadioButtonQuest
              key="everinc1"
              className="radio"
              labelName="Yes"
              labelClassName="align-items-center justify-content-center btn-next next5"
              onClick={optionHandle}
              value="247"
              name="everIncresedCredLimit"
              id="everinc1"
              dataQuestId={92}
              dataAnsId={247}
              dataAnsLabel="Yes"
            />
          </div>
        </li>
        <li>
          <div className="option_but btn-next ">
            <RadioButtonQuest
              key="everinc2"
              className="radio"
              labelName="No"
              labelClassName="align-items-center justify-content-center btn-next next5"
              onClick={optionHandle}
              value="248"
              name="everIncresedCredLimit"
              id="everinc2"
              dataQuestId={92}
              dataAnsId={248}
              dataAnsLabel="No"
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default EverIncreCredLimit;
